import { getTable, getExportTable } from '../services';
export const fetchTable = params => getTable(params).then(response => formattedTable(response));
export const fetchExportTable = (preset, dates, fileType, responseType, query) => getExportTable(preset, dates, fileType, responseType, query).then(response => formatExport(response?.data));
const formattedTable = ({ data }) => {
    const result = {
        data: data?.data || [],
        series: data?.series || [],
        totalCount: data?.totalCount,
        errors: data?.errors || [],
    };
    return result;
};
const formatExport = (response) => response;
